const ShortLogoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M7.38466 3.45297H16.6155V0H7.38466C3.30623 0 0 3.09189 0 6.90593C0 10.72 3.30623 13.8119 7.38466 13.8119H11.077V10.3589H7.38466C5.34544 10.3589 3.69233 8.81295 3.69233 6.90593C3.69233 4.99891 5.34544 3.45297 7.38466 3.45297Z" fill="#A0363A" />
      <path d="M7.38466 17.0941H11.077L11.0768 24H7.3845L7.38466 17.0941Z" fill="#A0363A" />
      <path d="M16.6153 17.0941H12.923V20.547H16.6153C20.6938 20.547 24 17.4551 24 13.6411C24 9.82707 20.6938 6.73518 16.6153 6.73518L12.923 6.73518V10.1881H16.6153C18.6546 10.1881 20.3077 11.7341 20.3077 13.6411C20.3077 15.5481 18.6546 17.0941 16.6153 17.0941Z" fill="#A0363A" />
    </svg>
  );
};

export default ShortLogoIcon;
